import { MagnitIdClient } from '~/shared/api/magnit-id/MagnitIdClient';
import type { sendOtpParams, verifyOtpParams, loginParams, refreshTokenParams, sendOtpResponse, verifyOtpResponse, loginResponse, refreshTokenResponse } from '@/features/auth-sdk/model/authSDKModels';
import type { Options } from 'ky';

export class AuthSDKService extends MagnitIdClient {
  static instance: AuthSDKService | null = null;

  public static getInstance() {
    if (!AuthSDKService.instance) {
      AuthSDKService.instance = new AuthSDKService();
    }
    return AuthSDKService.instance;
  }

  constructor() {
    super({});
  }

  override async post<T>(url: string, data: any, options?: Options) {
    return super.post<T>(url, {
      ...data,
      aud: this.aud,
    }, {
      ...options,
      headers: {
        ...options?.headers,
        'x-device-tag': await this.getKasperskyDeviceTag(),
      }
    });
  }

  public async sendOtp(params: sendOtpParams) {
    return this.post<sendOtpResponse>('auth/otp', {
      phone: params.phone,
      'captcha-token': params.captcha,
    });
  }

  public async verifyOtp(params: verifyOtpParams) {
    return this.post<verifyOtpResponse>('auth/otp/check', params);
  }

  public async login(params: loginParams) {
    return this.post<loginResponse>('auth/token', params);
  }

  public async refreshToken(params: refreshTokenParams) {
    return this.post<refreshTokenResponse>('auth/token/refresh', params);
  }
}